import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/38/thumb-landscape.jpg"

const Post38 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">FENDI／バイザウェイスモール／19 x12 x9cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>「オンにもオフにも使える本物バッグが欲しい」<br></br>「どんなバッグを選んだら良いかわからない」
            <br></br>そんな悩みを抱えていませんか？
            <br></br>FENDI（フェンディ）「バイザウェイ」（BY THE WAY）は
            カラー展開の豊富さと程よいサイズ感が人気のバッグ。
            今回は、そんなバイザウェイの特徴や人気の理由おすすめコーディネート、サイズ、人気カラーなど、FENDI（フェンディ）の歴史も合わせてくわしくご紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>①FENDI（フェンディ）とは</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>②「バイザウェイ」（BY THE WAY）ってどんなバッグ？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>③3ｗａｙの持ち方をご紹介</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>④3つのサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>⑤人気カラー、サイズは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>⑥まとめ</ScrollLink>
        </p>
      </div>        
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/1.png" alt="FENDI（フェンディ）の定番人気バッグ バイザウェイ（BY THE WAY）とは？"/>
      </figure>    
      <div name="sec1" className="text-two-cloumn">
        <h2>①FENDI（フェンディ）とは</h2>
        <p>
          イタリアを代表する世界的ファッションブランド
          FENDI（フェンディ）は1925年にイタリア・ローマでアドーレ・フェンディ夫妻が皮革・毛皮の専門店としてスタート。
          1965年にモード界の巨匠カール・ラガーフェルドが毛皮コートのデザイナーとして入社しました。
          エナメル加工など様々な技法を取り入れた革新的なデザインが話題を呼び、毛皮のイメージを一新しました。
          1969年には毛皮コートのプレタポルテを発表し、40年代から裏地として使われていた「F」を組み合わせた柄を表側に使い、ここからブランドアイコンの「ダブルF」が誕生しました。この「ズッカ柄」は現在でも多くの商品に使われています。
        </p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/2.png" alt=""/>
        <span className="text-center">FENDI／バックパック／21 x24 x10cm</span>  
        <span className="text-center">ズッカ柄バッグ</span>
      </figure>
        <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
          フェンディのバッグを見る
        </Link>
      <div className="text-max-width">
        <p>1997年にはブランドの定番バッグともなる「バゲット」が発表されました。
        あの人気ドラマの主人公が愛用し一世を風靡したことでアイコンバッグとなりました。
        2019年には、バゲットが新デザインなって復活し、
        世界中から益々注目が集まっています。カール・ラガーフェルド亡き後2020年9月には、
        あのキム・ジョーンズ氏を迎え今後、ますます目が離せません。</p>
      </div>
      <div name="sec2" className="text-two-cloumn">
        <h2>②「バイザウェイ」（BY THE WAY）ってどんなバッグ？</h2>
        <p>
          BY THE WAY（バイザウェイ）は2014年に発売された、小さめのボストンバッグです。ボストンバッグをモチーフにした横長デザインと、上品でミニマルなサイズ感が特徴。カーフレザーを使用し程よい光沢感としなやかさでカジュアルやフォーマルなシーンにも活躍しそうです。
          ハンドルは左右にアジャスターがついていて、ボディ部分に収納できるデザイン。発売当初はバッグのハンドル部分とボディのカラーが同じ、ワンカラーのデザインでしたが、現在では、大人気のズッカ柄や、ボディとハンドルのカラーが違う、バイカラーのものも発売されています。
          バイザウェイ（BY THE WAY）の和訳は「ところで」と会話の流れを変える
          その名の通り、服装によって持ち方を変えられる3WAYバッグなんです。
        </p>
        <figure className="img-small">
          <StaticImage src="../../images/posts/38/3.png" alt=""/>
          <span className="text-center">
            上から順に<br></br>
            FENDI／バイザウェイミディアム／28 x15 x12cm<br></br>
            FENDI／バイザウェイミディアム／28 x15 x12cm<br></br>
            FENDI／バイザウェイミディアム／28 x18 x13cm
          </span>  
        </figure> 
      </div>
      <div name="sec3" className="text-max-width">
        <h2>③3wayの持ち方をご紹介</h2> 
      </div>
      <h2>1.ハンドバッグ</h2>
      <p>ハンドル部分を持った、スタンダードなスタイル。レザーの光沢感もありいつものカジュアルスタイルにも高級感が生まれますね！</p>
      <figure className="img-small"> 
        <StaticImage src="../../images/posts/38/4.jpg" alt=""/>
        <span className="text-center">FENDI／バイザウェイミディアム／28 x18 x13cm</span>  
      </figure>
      <h2>2.クラッチバッグ</h2>
      <p>ハンドル部分の収納が可能。クラッチバッグとしても持てます。クラッチにするとエレガントな大人な雰囲気へ印象が変わりますよね！</p>
      <div className="text-max-width">
        <h2>3.ショルダーバッグ</h2>
        <p>付属のショルダーを着けて、ショルダーバッグとして持てます。
        また、ショルダーストラップは長めなのでクロスボディバッグとして2wayでの使用も可能です。</p>
      </div>
      <div name="sec4" className="text-two-cloumn">
        <h2>④3つのサイズ展開</h2>
        <p>（公式サイトやブランドショップによってサイズ表記が異なっている場合がありますが、今回はラクサス表記にてご紹介いたします）<br></br>それでは、見ていきましょう！
        </p>
        <figure>
          <StaticImage src="../../images/posts/38/5.jpg" alt=""/>
        </figure>      
      </div>   
      <div className="text-max-width">
        <h2>1.バイザウェイミニ<span style={{'font-size': '1.6rem'}}>（スモールとも呼ばれますが、ラクサス表記ではミニ）</span>/19×12x9cm(幅x高さxマチ)</h2>
        <p>かなりコンパクトなサイズ感でありながらマチはしっかりあるので、休日お出かけバッグとして◎（小さめお財布、携帯、ポーチなど）しっかり収納可能です。カラーバッグを選ぶと、アクセサリー感覚でコーデのポイントバッグとしても♪</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/6.png" alt=""/>
      </figure>
      <figure>
        <StaticImage src="../../images/posts/38/7.jpg" alt=""/>
      </figure>
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/8.png" alt=""/>
      </figure>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/38/9.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/38/10.jpg" alt=""/>
        </figure>
      </div>
      <p className="text-max-width">
        おすすめカラーはトレンドのグリーン。中の仕切りは無く、コンパクトでありながら上品な印象です。付属のストラップをつけてショルダーとして持つことも可能。
      </p>
      <div className="text-max-width">
        <h2>2.バイザウェイスモール<span style={{'font-size': '1.6rem'}}>（公式ではミディアムとも呼ばれます）</span>/27×18×13cm(幅x高さxマチ)</h2>
        <p>一見、コンパクトに見えますが、こちらは長財布も入ります。やはりボストン型なので収納力抜群。カジュアルにもフォーマルにも使っていただけます。ショルダータイプからトップハンドル、ベーシックカラー、異素材の組み合わせ、複数のサイズ展開などバリエーション豊富。</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/11.png" alt=""/>
      </figure>
      <figure>
        <StaticImage src="../../images/posts/38/12.jpg" alt=""/>
      </figure>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/38/13.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/38/14.jpg" alt=""/>
        </figure>  
      </div>                      
      <p className="text-max-width">スモールは、中に仕切りがあります。ミニと比較するとバッグを持っているという安心感がありますよね。
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/15.png" alt=""/>
      </figure>            
      <p className="text-max-width">ハンドル部分がバイカラーのデザインを選んで。あえて、冬に寒色系のコーデもかわいい♡
      </p>
      <div className="text-max-width"><h2>
        3.バイザウェイラージ/32×18×15cm(幅x高さxマチ)</h2>
        <p>こちらはBY THE WAY（バイザウェイ）シリーズの中で一番大きいサイズになります。なんと、ラージは圧倒的に数が少ないとのこと。貴重バッグですね！ショルダーにすると、そこまで大きさは気にならないので通勤バッグとしても◎</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/16.png" alt=""/>
      </figure>           
      <figure>
        <StaticImage src="../../images/posts/38/17.jpg" alt=""/>
      </figure>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/38/18.jpg" alt=""/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/38/19.jpg" alt=""/>
        </figure>
      </div>
      <p className="text-max-width">
        ラージは天口もしっかり開き、収納力抜群なので、お出かけにもぴったり♪<br></br>ベーシックカラーを選んでも♡
      </p>
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/20.png" alt=""/>
      </figure> 
      <div name="sec5" className="text-max-width">
        <h2>⑤人気カラー、サイズは？</h2>
      </div>
      <h2>バイ ザ ウェイミニ</h2>
      <p>豊富なカラー展開の「バイザウェイ」（BY THE WAY）ですが、昨年よりブラウンのレザーのフロント部分に熱転写で「FENDI ROMA」の文字を飾った新しいデザインも発売されこちらも人気です。<br></br>サイズ感については、休日もお仕事でも使用したいという方は「スモールorラージのベーシックカラー」アクセサリー感覚の休日用バッグとして「ミニ（カラーアイテム）」が人気のようです。</p>                                                   
      <figure>
        <StaticImage src="../../images/posts/38/21.jpg" alt=""/>
        <span className="text-center">FENDI／バイザウェイスモール／19 x13 x9cm</span>  
      </figure>
      <figure className="img-small">
        <StaticImage src="../../images/posts/38/22.png" alt=""/>
      </figure>          
      <div name="sec6" className="text-two-cloumn">
        <h2>⑥まとめ</h2>
        <p>
          いかがでしたでしょうか？3サイズ、カラー展開豊富な「バイザウェイ」（BY THE WAY）1つ取り入れるだけで、コーディネートの幅が広がりますよね。あなたはどのカラーを選びますか？
        </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/38/23.jpg" alt=""/>
        <span className="text-center">
          奥から順に<br></br>
          FENDI／バイザウェイミディアム／28 x18 x13cm<br></br>
          FENDI／バイザウェイミディアム／28 x15 x12cm<br></br>
          FENDI／バイザウェイミディアム／28 x15 x12cm
        </span>  
      </figure>       
      <Link to="https://laxus.co/app/pc/bags/fendi" className="view-all-button">
        フェンディのバッグを見る
      </Link>
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post38

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 38}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
